module.exports = __webpack_public_path__ + "static/media/rifa_Carro.6e239e4b.jpeg";